import { AttachmentType, WhatsAppMessageType } from 'src/api/generated';
import { WhatsAppMediaType } from './media.util';

/**
 * Maps WhatsApp media type to message type for API consumption
 */
export const mapMediaTypeToMessageType = (
  mediaType: WhatsAppMediaType
): WhatsAppMessageType => {
  switch (mediaType) {
    case WhatsAppMediaType.IMAGE:
      return WhatsAppMessageType.IMAGE;
    case WhatsAppMediaType.VIDEO:
      return WhatsAppMessageType.VIDEO;
    case WhatsAppMediaType.AUDIO:
      return WhatsAppMessageType.AUDIO;
    case WhatsAppMediaType.DOCUMENT:
      return WhatsAppMessageType.DOCUMENT;
    case WhatsAppMediaType.STICKER:
      return WhatsAppMessageType.STICKER;
    default:
      return WhatsAppMessageType.DOCUMENT;
  }
};

export const mapMediaTypeToAttachmentType = (
  mediaType: WhatsAppMediaType
): AttachmentType => {
  switch (mediaType) {
    case WhatsAppMediaType.IMAGE:
      return AttachmentType.IMAGE;
    case WhatsAppMediaType.VIDEO:
      return AttachmentType.VIDEO;
    case WhatsAppMediaType.AUDIO:
      return AttachmentType.AUDIO;
    case WhatsAppMediaType.DOCUMENT:
      return AttachmentType.FILE;
    case WhatsAppMediaType.STICKER:
      return AttachmentType.FILE;
    default:
      return AttachmentType.FILE;
  }
};
